// Absolute temperature: Celsius → display unit
export const toDisplayTemp = (celsius, unit) =>
  unit === '°F' ? Math.round((celsius * 9 / 5 + 32) * 10) / 10 : celsius

// Display unit → Celsius (for saving back to DB)
export const toCelsius = (displayVal, unit) =>
  unit === '°F' ? Math.round(((displayVal - 32) * 5 / 9) * 10) / 10 : displayVal

// Temperature delta/range (no +32 offset): Celsius → display unit
export const toDisplayDelta = (celsius, unit) =>
  unit === '°F' ? Math.round((celsius * 9 / 5) * 10) / 10 : celsius

// Display unit delta → Celsius delta
export const fromDisplayDelta = (val, unit) =>
  unit === '°F' ? Math.round((val * 5 / 9) * 10) / 10 : val

// Format a threshold temperature for use in labels, e.g. displayThreshold(10, '°F') → "50°F"
export const displayThreshold = (celsius, unit) =>
  unit === '°F' ? `${Math.round(celsius * 9 / 5 + 32)}°F` : `${celsius}°C`
